import { Flex, Icon, Text, useToast } from '@chakra-ui/react'
import * as T from '../../../components/Table'
import { format } from 'date-fns'
import { Link } from 'react-router-dom'
import { FaEdit } from 'react-icons/fa'
import { ModalDeletarArtigo } from './ModalDeletarArtigo'
import { useMutation, useQueryClient } from 'react-query'
import { api } from '../../../services/api'

async function deleteArtigo({ id }) {
  const response = await api.delete(`/crm-interno/deletar-artigo/${id}`)

  return response.data
}

function hasImage(article) {
  const heroImage = article?.hero_image
  const imageConclusion = article?.conclusao?.image_url

  if (!heroImage && !imageConclusion) return false

  return true
}

export function ArtigoItem({ article }) {
  const queryClient = useQueryClient()
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
  })

  const { mutateAsync: deleteArtigoAsync, isLoading: isLoadingDeleteArtigo } = useMutation({
    mutationKey: 'deleteArtigo',
    mutationFn: ({ id }) => deleteArtigo({ id }),
    onSuccess: () => {
      queryClient.invalidateQueries('articles')
      toast({
        title: 'Artigo deletado com sucesso',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao deletar o artigo',
        status: 'error',
      })
    },
  })

  async function handleDeleteArtigo(id) {
    await deleteArtigoAsync({ id })
  }

  return (
    <T.Tr key={article.artigo_id}>
      <T.Td
        bgColor={!hasImage(article) && 'rgba(255, 0, 0, 0.1)!important'}
        textAlign="start"
        px={2}
        py="1"
        borderRight="1px solid #378BBF!important"
      >
        <Text
          isTruncated
          textTransform={'initial'}
          as={article.artigo_aprovado ? 'a' : 'span'}
          href={`https://innovationbrindes.com.br/responde/artigo/${article.slug}`}
          target="_blank"
          rel="noreferrer"
          {...(article.artigo_aprovado && { color: 'blue.500', textDecoration: 'underline' })}
        >
          {article.titulo}{' '}
          {!hasImage(article) && (
            <Text color="red.500" as="span">
              Falta imagem no artigo
            </Text>
          )}
        </Text>
      </T.Td>
      <T.Td py="1" w="250px" borderRight="1px solid #378BBF!important">
        <Text textTransform={'lowercase'}>{article.data_criacao ? format(new Date(article.data_criacao), "dd/MM/yyyy 'às' HH:mm") : 'Sem data'}</Text>
      </T.Td>
      <T.Td py="1" w="250px" borderRight="1px solid #378BBF!important">
        {article.nome_categoria ?? 'Sem categoria'}
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        {article.palavra_chave}
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        {article?.data_aprovacao && (
          <Flex flexDir="column" alignItems="center">
            <Text textTransform="lowercase">{format(new Date(article.data_aprovacao), "dd/MM/yyyy 'às' HH:mm")}</Text>
            <Text>
              <strong>{article.nome_usuario}</strong>
            </Text>
          </Flex>
        )}
      </T.Td>
      <T.Td py="1" w="100px" borderRight="1px solid #378BBF!important">
        <Flex as={Link} to={`/adm/artigos/${article.slug}`} alignItems="center" justifyContent="center" gap={2} cursor="pointer">
          <Text>Editar</Text>
          <Icon as={FaEdit} fontSize="lg" color="#FFA200" />
        </Flex>
      </T.Td>

      <T.Td py="1" w="100px">
        <ModalDeletarArtigo onConfirm={() => handleDeleteArtigo(article.artigo_id)} isLoading={isLoadingDeleteArtigo} />
      </T.Td>
    </T.Tr>
  )
}
